import { documentQueryKeys } from "./queryKeys"
import { useDocumentQuery } from "./useDocumentQuery"

export function useDocumentAuthors(params = {}) {
    const url = "documents/created_by/"
    const queryKey = documentQueryKeys.authors(params)

    return useDocumentQuery(
        url,
        queryKey,
        params,
        {
            autoRefetch: true,
        },
    )
}